import { Button, Grid, LinearProgress, MobileStepper } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import { calculateDrivingHours } from 'helpers/DrivingHoursConverter';
import { ParseUriParams } from 'helpers/UriReader';
import {
	GetUserId,
	GetUserKey,
	GetUserToken,
	Logout
} from 'helpers/UserHelper';
import moment from 'moment';
import { ClientQuoteInfo } from 'queries/quotes/queries.js';
import { newQuoteMutation } from 'queries/Submit';
import React, { Component } from 'react';
import { graphql, Query } from 'react-apollo';
import { Redirect } from 'react-router';
import { showSnack, successWarning } from 'reducers/NotificationReducer';
import { openProgress, addPendingTask } from 'reducers/TasksReducer';
import { reduxForm } from 'redux-form';
import store from 'store';
import BenefitDetails from './steps/BenefitDetails.jsx';
import BenefitSelection from './steps/BenefitSelection.jsx';
import CompanySelectionPageNew from './steps/CompanySelection.jsx';
import CompanySpecific from './steps/CompanySpecific.jsx';
import QuoteDetailsPage from './steps/QuoteDetails.jsx';
import BenefitMapping from './steps/BenefitMapping';

class QuoteWizard extends Component {
	constructor(props) {
		super(props);
		this.nextPage = this.nextPage.bind(this);
		this.previousPage = this.previousPage.bind(this);
		this.state = {
			page: 0,
			pageCount: 6,
			checkValidation: false,
			formInitiazed: false,
			benefitsInitialized: false,
			br: false,
			mat100: 0,
			mat75: 0,
			clientId: null,
			guid: null,
			selectedTargets: [],
			selectedBenefits: [],
			clientAge: null
		};
	}

	componentDidMount() {
		const params = ParseUriParams(this.props.location.search);
		const { clientId, guid } = params;
		this.setState({ clientId: clientId, guid: guid });
	}

	initializeForm(data) {
		const defaultInit = {
			//Fields you can't see
			Admin: data.scd_pAdmin,
			Travel: data.scd_pTravel,
			ManualLabour: data.scd_pManual,
			Supervision: data.scd_pSupervision,
			spouseIncome: data.scd_spouseIncome,
			title: data.scd_title,
			name: data.scd_name,
			surname: data.scd_surname,
			dateOfBirth: data.scd_dateOfBirth,
			gender: data.scd_gender,
			smoker: data.scd_smoker,
			qualification: data.scd_qualification,
			occupation: data.scd_occupation,
			selfEmployed: data.scd_selfEmployed,
			income: data.scd_monthlyIncome,
			salaryType: data.scd_salaryType,
			maritalStatus: data.scd_maritalStatus,
			TaxDispensation: data.scd_taxDispensation,
			calculatedMonthlyIncomeAT: data.scd_calculatedMonthlyIncomeAT
				? data.scd_calculatedMonthlyIncomeAT
				: '0',
			actualMonthlyIncomeAT: data.scd_actualMonthlyIncomeAT
				? data.scd_actualMonthlyIncomeAT
				: '0',
				ID : data.scd_saID,
			//Fields you can see
			comission: '100',
			percentageUpfronCommission: '100',
			PAAWCommission: '0',
			language: 'English'
		};

		let editData = {};

		if (this.state.guid) {
			//Auto Populate targets
			let { selectedTargets } = this.state;
			let editTargets = data.targets.split(',').map(t => parseInt(t, 10));
			let availTargets = data.AvailTargetsForBroker.map(t =>
				parseInt(t.id, 10)
			);
			editTargets.map(t => {
				if (availTargets.includes(t)) {
					selectedTargets.push(t);
				}
				return t;
			});
			this.setState({ selectedTargets: selectedTargets });

			editData = JSON.parse(data.formValues);

			if (editData.occupation !== data.scd_occupation) {
				delete editData.occupation;
				delete editData.occupationalQs;
			}

			editData = this.deleteClientFields(editData);
		}

		this.props.initialize({
			...editData,
			...defaultInit
		});

		if (data.scd_calculatedMonthlyIncomeAT) {
			var calcAt = parseFloat(data.scd_calculatedMonthlyIncomeAT);
			if (data.scd_actualMonthlyIncomeAT) {
				var acAt = parseFloat(data.scd_actualMonthlyIncomeAT);
				var value = Math.max(calcAt, acAt);
				this.setState({ mat75: value * 0.75, mat100: value });
			} else {
				this.setState({ mat75: calcAt * 0.75, mat100: calcAt });
			}
		}

		var age = moment().diff(data.scd_dateOfBirth, 'years');

		this.setState({ formInitiazed: true, clientAge: age });
	}

	deleteClientFields(editData) {
		delete editData.Admin;
		delete editData.Travel;
		delete editData.ManualLabour;
		delete editData.Supervision;
		delete editData.spouseIncome;
		delete editData.title;
		delete editData.name;
		delete editData.surname;
		delete editData.dateOfBirth;
		delete editData.gender;
		delete editData.smoker;
		delete editData.qualification;
		delete editData.occupation;
		delete editData.selfEmployed;
		delete editData.income;
		delete editData.salaryType;
		delete editData.maritalStatus;
		delete editData.TaxDispensation;
		delete editData.calculatedMonthlyIncomeAT;
		delete editData.actualMonthlyIncomeAT;
		delete editData.comission;
		delete editData.percentageUpfronCommission;
		delete editData.PAAWCommission;
		delete editData.language;
		delete editData.startDate;

		return editData;
	}

	checkSelectedTarget = (id, checked) => {
		let selectedTargets = [...this.state.selectedTargets];

		if (checked) {
			selectedTargets.push(id);
		} else {
			selectedTargets = selectedTargets.filter(t => t !== id);
		}

		this.setState({ selectedTargets: selectedTargets });
	};

	toggleAllTargets = (targets, checked) => {
		let selectedTargets = [...this.state.selectedTargets];
		if (checked) {
			targets.map(t => {
				if (!selectedTargets.includes(t.id)) {
					selectedTargets.push(t.id);
				}
				return t;
			});
		} else {
			selectedTargets = [];
		}

		this.setState({ selectedTargets: selectedTargets });
	};

	checkSelectedBenefit = (id, checked) => {
		let selectedBenefits = [...this.state.selectedBenefits];

		if (checked) {
			selectedBenefits.push(id);
		} else {
			selectedBenefits = selectedBenefits.filter(t => t !== id);
		}

		this.setState({ selectedBenefits: selectedBenefits });
	};

	toggleAllBenefits = (benefits, checked) => {
		let selectedBenefits = [...this.state.selectedBenefits];
		if (checked) {
			benefits.map(b => {
				if (!selectedBenefits.includes(b.id)) {
					selectedBenefits.push(b.id);
				}
				return b;
			});
		} else {
			selectedBenefits = [];
		}

		this.setState({ selectedBenefits: selectedBenefits });
	};

	checkCommision() {
		let values = store.getState().form.quotev2.values;
		if (!values) return true;

		let total =
			parseInt(values['percentageUpfronCommission'], 10) +
			parseInt(values['PAAWCommission'], 10);
		if (total !== parseInt(values['comission'], 10)) {
			return false;
		}
		return true;
	}

	nextPage() {
		if (this.state.page === 0 || this.state.page === 2) {
			this.pushNextPage();
			this.forceUpdate();
			return;
		}

		let comErr = this.state.page === 1 && !this.checkCommision();

		if (store.getState().form.quotev2.syncErrors || comErr) {
			comErr
				? this.showDangerSnack(
						`Upfront commission and As-and-when commission do not add up to total commission percentage`
				  )
				: this.showDangerSnack('Invalid Information');
			this.setState({ checkValidation: true });
		} else {
			this.pushNextPage();
		}
		this.forceUpdate();
	}

	previousPage() {
		this.setState({ checkValidation: false, page: this.state.page - 1 });
	}

	pushNextPage = () => {
		this.setState({ page: this.state.page + 1 });
		this.setState({ checkValidation: false });
	};

	showDangerSnack(message) {
		store.dispatch(
			showSnack({
				message: message,
				color: 'danger'
			})
		);
	}

	checkAssistantActive() {
		return GetUserKey('userType') === '6' ? true : false;
	}

	getBrokerId = () => {
		let brokerId = GetUserId();
		if (this.checkAssistantActive()) {
			brokerId = sessionStorage.getItem('ActiveBrokerId');
		}
		return brokerId;
	};

	submit() {
		if (store.getState().form.quotev2.syncErrors) {
			this.setState({ checkValidation: true });
			store.dispatch(
				showSnack({
					message: 'Invalid Information',
					color: 'danger'
				})
			);
		} else {
			this.setState({ checkValidation: false });

			const fieldValuesRaw = { ...store.getState().form.quotev2.values };

			var pTravel = store.getState().form.quotev2.values.Travel;

			fieldValuesRaw.drivingHours = calculateDrivingHours(pTravel);

			fieldValuesRaw['medicalSecondOpinion'] = 'Y';

			const params = ParseUriParams(this.props.location.search);
			const { clientId } = params;

			const input = {
				token: GetUserToken(),
				userId: this.getBrokerId(),
				clientId: clientId,
				benefits: this.state.selectedBenefits,
				assistantId: GetUserKey('userType') === '6' ? GetUserId() : null,
				targets: this.state.selectedTargets,
				data: fieldValuesRaw
			};

			this.props
				.mutate({
					variables: {
						input
					}
				})
				.then(resp => {
					console.log('resp: ', resp);
					store.dispatch(
						successWarning({
							open: true,
							title: 'Quote Submitted!'
						})
					);
					store.dispatch(openProgress());
					store.dispatch(
						addPendingTask({
							task: {
								description: fieldValuesRaw.description,
								guid: resp.data.newQuote.guid,
								client: `${fieldValuesRaw.name} ${fieldValuesRaw.surname}`
							}
						})
					);
				})
				.catch(error => {
					store.dispatch(
						showSnack({
							message:
								'There was an error creating your new broker profile : ' +
								error,
							color: 'danger'
						})
					);
				});
		}
		return false;
	}

	render() {
		const { page } = this.state;
		const params = ParseUriParams(this.props.location.search);
		const { clientId, guid } = params;

		return (
			<Query
				query={ClientQuoteInfo}
				variables={{
					brokerId: this.getBrokerId(),
					clientId: clientId,
					guid: guid,
					token: GetUserToken()
				}}
				fetchPolicy="network-only"
			>
				{({ loading, error, data }) => {
					if (loading)
						return (
							<div>
								<LinearProgress />
							</div>
						);
					if (
						error &&
						error.message &&
						error.message === 'GraphQL error: invalid token'
					) {
						Logout();
						return <Redirect to="/app/portal/login" />;
					}

					if (error) return `Error! ${error.message}`;

					if (!this.state.formInitiazed) {
						this.initializeForm(data.ClientQuoteInfo);
					}

					let clientFullname = `${data.ClientQuoteInfo.scd_title} ${
						data.ClientQuoteInfo.scd_name
					} ${data.ClientQuoteInfo.scd_surname}`;

					return (
						<React.Fragment>
							<Grid container>
								 <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: "auto" }}>
									<div className={'fixedStepper'}>
										<Grid container>
											<GridItem
												xs={12}
												sm={12}
												md={10}
												style={{ margin: 'auto' }}
											>
												<div className={'stepperDiv'}>
													<MobileStepper
														type="progress"
														steps={this.state.pageCount}
														position="static"
														activeStep={this.state.page}
														nextButton={
															<div style={{ display: 'flex' }}>
																{this.state.page ===
																this.state.pageCount - 1 ? (
																	<Button
																		variant="outlined"
																		className="outlinedButton"
																		color="secondary"
																		style={{ marginRight: '10px' }}
																		onClick={() => this.submit()}
																	>
																		Submit
																	</Button>
																) : (
																	<Button
																		disabled={
																			this.state.selectedTargets.length < 1 ||
																			(this.state.page === 2 &&
																				this.state.selectedBenefits.length < 1)
																		}
																		variant="outlined"
																		className="outlinedButton"
																		color="secondary"
																		style={{ marginRight: '10px' }}
																		onClick={() => this.nextPage()}
																	>
																		Next
																	</Button>
																)}
															</div>
														}
														backButton={
															<Button
																variant="outlined"
																className="outlinedButton"
																color="secondary"
																style={{ marginLeft: '10px' }}
																onClick={() => this.previousPage()}
																disabled={this.state.page === 0 ? true : false}
															>
																Back
															</Button>
														}
													/>
												</div>
											</GridItem>
										</Grid>
									</div>

									<br />
									{page === 0 && (
										<div style={{ color: 'black' }}>
											<CompanySelectionPageNew
												{...this.props}
												checkSelectedTarget={this.checkSelectedTarget}
												selectedTargets={this.state.selectedTargets}
												toggleAllTargets={this.toggleAllTargets}
												AvailTargetsForBroker={
													data.ClientQuoteInfo.AvailTargetsForBroker
												}
												clientFullname={clientFullname}
												autoPopulatedCompanies={data.ClientQuoteInfo.targets}
											/>
										</div>
									)}
									{page === 1 && (
										<QuoteDetailsPage
											{...this.props}
											targets={this.state.selectedTargets}
											checkValidation={this.state.checkValidation}
											clientFullname={clientFullname}
										/>
									)}
									{page === 2 && (
										<BenefitSelection
											{...this.props}
											checkSelectedBenefit={this.checkSelectedBenefit}
											selectedBenefits={this.state.selectedBenefits}
											toggleAllBenefits={this.toggleAllBenefits}
											clientAge={this.state.clientAge}
											doesNotQualifyForIP={
												data.ClientQuoteInfo.doesNotQualifyForIP
											}
											clientFullname={clientFullname}
											autoPopulatedBenefits={data.ClientQuoteInfo.benefits}
											benefitsInitialized={this.state.benefitsInitialized}
											setBenefitsInitialized={benefits =>
												this.setState({
													benefitsInitialized: true,
													selectedBenefits: benefits
												})
											}
										/>
									)}
									{page === 3 && (
										<BenefitMapping
											{...this.props}
											checkValidation={this.state.checkValidation}
											selectedBenefits={this.state.selectedBenefits}
											selectedTargets={this.state.selectedTargets}
											clientFullname={clientFullname}
										/>
									)}
									{page === 4 && (
										<BenefitDetails
											{...this.props}
											checkValidation={this.state.checkValidation}
											mat100={this.state.mat100}
											mat75={this.state.mat75}
											selectedBenefits={this.state.selectedBenefits}
											selectedTargets={this.state.selectedTargets}
											disOnlyImpairment={data.ClientQuoteInfo.disOnlyImpairment}
											clientFullname={clientFullname}
											clientAge={parseInt(data.ClientQuoteInfo.scd_age, 10)}
											clientAnualSalary={
												parseInt(data.ClientQuoteInfo.scd_monthlyIncome, 10) *
												12
											}
											occupation={data.ClientQuoteInfo.scd_occupation}
											qualification={data.ClientQuoteInfo.scd_qualification}
											AvailTargetsForBroker={
												data.ClientQuoteInfo.AvailTargetsForBroker
											}
										/>
									)}
									{page === 5 && (
										<CompanySpecific
											{...this.props}
											checkValidation={this.state.checkValidation}
											client={data.ClientQuoteInfo}
											selectedTargets={this.state.selectedTargets}
											clientFullname={clientFullname}
										/>
									)}
								</GridItem>
							</Grid>
						</React.Fragment>
					);
				}}
			</Query>
		);
	}
}

QuoteWizard = reduxForm({
	form: 'quotev2',
	destroyOnUnmount: true
})(QuoteWizard);

QuoteWizard = graphql(newQuoteMutation)(QuoteWizard);

export default QuoteWizard;



// WEBPACK FOOTER //
// ./src/views/Quote/QuoteWizard/QuoteWizard.jsx